import Cart from "./Cart.js";
import Router from "./Router.js";

import { langHandler } from "./langHandler.js";

const lang = langHandler.getLang();

const routes = [
  {
    path: "/",
    queryParamKeys: [], // no query expected
    title: "Home",
    handler: (routerInstance) => {
      const cart = new Cart(lang);
      cart.init(routerInstance);
    },
  },
  {
    path: "/fr",
    queryParamKeys: [], // no query expected
    title: "Home",
    handler: (routerInstance) => {
      const cart = new Cart(lang);
      cart.init(routerInstance);
    },
  },
  {
    path: "/fr/",
    queryParamKeys: [], // no query expected
    title: "Home",
    handler: (routerInstance) => {
      const cart = new Cart(lang);
      cart.init(routerInstance);
    },
  },
  {
    path: "/",
    // for example, if you want to handle “/?a=1&b=2”:
    queryParamKeys: ["invoicenumber", "orderId", "redirect_status", "payment_intent", "payment_intent_client_secret"],
    title: "HomeWithAB",
    handler: (routerInstance) => {
      const cart = new Cart(lang);
      cart.init(routerInstance, true);
    },
  },
  {
    path: "/fr/",
    // for example, if you want to handle “/?a=1&b=2”:
    queryParamKeys: ["invoicenumber", "orderId", "redirect_status", "payment_intent", "payment_intent_client_secret"],
    title: "HomeWithAB",
    handler: (routerInstance) => {
      const cart = new Cart(lang);
      cart.init(routerInstance, true);
    },
  },
  {
    path: "/thankyou",
    queryParamKeys: [],
    title: "About",
    component: "About",
  },
];

new Router(routes, window.location);
